import { getPathForFileName } from "src/modules/activity-log/lib/fs-helpers";

const { Readable } = window.require("stream") || {};
const ffmpeg = window.require("fluent-ffmpeg");

const remote = window.require("@electron/remote");
const { unlink } = window.require("fs")?.promises || {};

const { getBinaryPath } = remote.require?.("../binaries") || {};

export default async function convertWebmToMp4({ webmData, fileName }) {
  return new Promise(async (resolve, reject) => {
    const readable = Readable.from([new Uint8Array(webmData)], {
      objectMode: false
    });

    ffmpeg(readable)
      .setFfmpegPath(getBinaryPath("ffmpeg"))
      .setFfprobePath(getBinaryPath("ffprobe"))
      .videoCodec("copy")
      .format("mp4")
      .on("error", (err) => {
        unlink(getPathForFileName(fileName));
        reject();
      })
      .on("end", () => resolve(1))
      .save(getPathForFileName(fileName));
  });
}
